module.exports = "/static/media/success.b9ad0f34.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/success.png
// module id = 1810
// module chunks = 0